// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.prototype.$routers = router
import VueScrollReveal from 'vue-scroll-reveal';
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal',
  duration: 1000,
  scale: 1,
  distance: '200px',
  reset: false,
  mobile: false,
  cleanup: false,
  useDelay: 'once',
  origin: 'bottom',
  delay: 400
});
router.afterEach((to, from, next) => {

  document.body.scrollTop = 0;

  document.documentElement.scrollTop = 0;

});
Vue.directive('title', { //单个修改标题
  inserted: function(el, binding) {
    document.title = el.dataset.title
  }
})
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js